import { routes } from '~/constants';
import { RequiredConsentName } from '~/root/Auth';

type ExtendedConsent = {
  value: string;
  name: string;
  shortName: string;
  link: string;
};

export const consentsMap: Record<RequiredConsentName, ExtendedConsent> = {
  terms_and_conditions: {
    value: 'terms_and_conditions',
    name: 'Terms and Conditions',
    shortName: 'Terms',
    link: routes.public.documents.terms_and_conditions,
  },
  privacy_policy: {
    value: 'privacy_policy',
    name: 'Privacy Policy',
    shortName: 'Privacy Policy',
    link: routes.public.documents.privacy_policy,
  },
  dpa: {
    value: 'dpa',
    name: 'Data Processing Agreement',
    shortName: 'DPA',
    link: routes.public.documents.data_processing_agreement,
  },
};
